import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import "../css/terms.scss";

function Terms() {
  return (
    <div className="terms">
      <Header />
      <main><div className="inner-pg"><div className="content">
        <h1>Terms of Service</h1>
        <p>Last updated: September 8, 2026</p>
        <p>These terms apply when you visit the shiskerstone website or place an order. By using the website, you agree to these terms and to the policies linked from it.</p>
        <strong>Store information</strong>
        <p>Product descriptions, availability, prices, and images may be updated without notice. Natural materials and hand finishing can produce small variations. We try to display color accurately, but screens differ.</p>
        <strong>Orders and payment</strong>
        <p>An order is an offer to purchase. We may accept, refuse, or cancel an order for availability, payment, pricing, fraud-prevention, legal, or delivery reasons. If a cancelled order has been charged, the applicable amount will be refunded. You must provide current and accurate checkout information.</p>
        <strong>Shipping, returns, and repairs</strong>
        <p>Estimated timing and eligibility rules appear in our Shipping and Returns policies. Made-to-order, altered, personalized, worn, or final-sale items may have different conditions where clearly disclosed before purchase.</p>
        <strong>Acceptable use</strong>
        <p>You may not misuse the website, interfere with its security, introduce malicious code, collect data without permission, impersonate another person, or use the store for unlawful or fraudulent activity.</p>
        <strong>Intellectual property</strong>
        <p>The shiskerstone name, original text, graphics, product imagery, and site content are owned by or licensed to shiskerstone. You may use the website for personal shopping but may not reproduce or exploit its content commercially without written permission.</p>
        <strong>Third-party services</strong>
        <p>Checkout, fonts, delivery, and other functions may be provided by third parties. Their services and notices may apply when you use those features. We are not responsible for third-party sites outside our control.</p>
        <strong>Disclaimer and liability</strong>
        <p>To the extent permitted by law, the website is provided without guarantees beyond those expressly stated. Nothing in these terms excludes rights or liability that cannot legally be excluded. Our liability for a product claim will not exceed the amount paid for the affected product except where applicable law requires otherwise.</p>
        <strong>Changes, severability, and contact</strong>
        <p>We may revise these terms prospectively. If one provision is unenforceable, the remaining provisions continue. Questions may be sent to <u>print@shiskerstone.xyz</u>.</p>
      </div></div></main>
      <Footer />
    </div>
  );
}

export default Terms;
